import axios from "axios";
import qs from "qs";

import { BASE_URL, API_V1_URL, API_V2_URL } from "../../shared/constants/env";

import { onRequest, onRequestError } from "../interceptors/request";
import { onResponseError } from "../interceptors/response";

const axiosCreator = ({ api, params }) =>
  axios.create({
    baseURL: `${BASE_URL}${api}`,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });

export const apiV1 = axiosCreator({ api: API_V1_URL });
export const apiV2 = axiosCreator({ api: API_V2_URL });

apiV1.interceptors.request.use(onRequest, onRequestError);
apiV1.interceptors.response.use((response) => response, onResponseError(apiV1));

apiV2.interceptors.request.use(onRequest, onRequestError);
apiV2.interceptors.response.use((response) => response, onResponseError(apiV2));
